import {InjectionToken} from '@angular/core';

export const TEXT_LANGAUGE       = new InjectionToken('#im/text/language');
export const TEXT_BASE_LANGAUGE  = new InjectionToken('#im/text/base-language');